import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

class Tab extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    link: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    subTabs: PropTypes.array,
  }

  render() {
    const {
      title,
      icon,
      isActive,
      onClick,
      link,
      disabled,
      subTabs,
    } = this.props

    const tabClassName = classNames(
      'flexbox flexbox-align-center',
      'transition',
      'font-size-normal font-weight-medium',
      'padding-vertical-medium padding-horizontal-large',
      'shade-05',
      {
        'background-shade-50-on-hover background-shade-50-on-focus pointer':
          !disabled && !isActive,
        'background-shade-50': isActive,
        'cursor-forbidden shade-20': disabled,
      }
    )
    const iconClassName = classNames('margin-right-normal shade-30')
    return (
      <React.Fragment>
        {!!onClick && (
          <div className={tabClassName} onClick={disabled ? null : onClick}>
            {!!icon &&
              React.createElement(icon, {
                size: 16,
                className: iconClassName,
              })}
            {title}
          </div>
        )}
        {!!link && (
          <Link className={tabClassName} to={link}>
            {!!icon &&
              React.createElement(icon, {
                size: 16,
                className: iconClassName,
              })}
            {title}
          </Link>
        )}
        {isActive &&
          subTabs &&
          subTabs.map((subTab, index) => {
            return (
              <Link
                key={subTab.id}
                to={subTab.link}
                className={classNames(
                  'padding-vertical-normal margin-left-largest padding-left-smaller font-weight-medium',
                  subTab.isActive ? 'primary' : 'shade-10'
                )}
              >
                {subTab.title}
              </Link>
            )
          })}
      </React.Fragment>
    )
  }
}

class SettingVerticalTabs extends PureComponent {
  static propTypes = {
    tabs: PropTypes.array.isRequired,
  }

  render() {
    return (
      <div className="flexbox flexbox-column scrollable">
        {this.props.tabs.map(tab => (
          <Tab {...tab} key={tab.id} />
        ))}
      </div>
    )
  }
}

export default SettingVerticalTabs
